import React from "react";
import List from "../../../components/list/List";
import connect from "react-redux/es/connect/connect";
import { setSort } from "../../../redux/actions/userActions";

class ListContainer extends React.Component {
	state = {
		sortOrder: true,
	};
	render() {
		// const columns = this.props.columns.map(column => {
		// 	let newColumn = {
		// 		title: column.title,
		// 		dataIndex: column.key,
		// 		key: column.key,
		// 	};
		// 	if (column.sortable) {
		// 		newColumn.onHeaderCell = () => {
		// 			return {
		// 				onClick: () => {
		// 					this.setState({ sortOrder: !this.state.sortOrder }, () => {
		// 						this.state.sortOrder
		// 							? this.props.setSort(column.key, 1)
		// 							: this.props.setSort(column.key, -1);
		// 					});
		// 				},
		// 			};
		// 		};
		// 		newColumn.sorter = () => 0;
		// 	}
		// 	if (column.render) {
		// 		newColumn.render = column.render;
		// 	}
		// 	return newColumn;
		// });

		return <List columns={this.props.columns} data={this.props.data} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		data: ownProps.data || [],
		page: state.user.page,
		pages: state.user.pages,
		columns: ownProps.columns,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setSort: (column, sortOrder) =>
			dispatch(setSort({ column: column, sortOrder: sortOrder })),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListContainer);



// WEBPACK FOOTER //
// src/containers/admin/users/ListContainer.js